<template>
  <div class="com">
    <div class="input-wrap">
      <input
        v-mask="'XX - XX - XXX - XXXX'"
        id="kit-id"
        type="text"
        class="input"
        placeholder="Enter Kit ID"
        v-model="enterKit"
        name="kit_id"
        @paste="paste"
        :class="{ invalid: errors.has('kit_id') }"
        v-validate="{ required: true, length: 20 }"
      />
      <span class="validate-error bottom-position" v-if="errors.has('kit_id') && errorCase == null">
        {{ setError(errors.first("kit_id")) }}
      </span>
      <span class="validate-error bottom-position" v-if="errorCase == 'already_registered'">
        Kit is already activated, please 
        <router-link to="/login" tag="a" class="login-link">
             sign in.</router-link
          >
      </span>
      <span class="validate-error bottom-position" v-else-if="errorCase == 'exist_validation'">
        This Kit ID is not available. Please 
        <a :href="contact_link" target="_blank" class="login-link">contact support.</a>
      </span>
      <span class="validate-error bottom-position" v-else-if="errorCase == 'archived'">
        This Kit has been archived. Please 
        <a :href="contact_link" target="_blank" class="login-link">contact support.</a>
      </span>
    </div>
    <div class="input-wrap">
      <input
        v-mask="'XX - XX - XXX - XXXX'"
        id="kit-verify"
        type="text"
        class="input"
        @paste="paste"
        @change="validate"
        placeholder="Confirm Kit ID"
        v-model="verifyKit"
        name="confirm_kit_id"
        v-validate="{ required: true, is: enterKit }"
      />
      <span class="validate-error" v-if="errors.has('confirm_kit_id')">
        {{ errors.first("confirm_kit_id") }}
      </span>
    </div>
    <button
      class="btn"
      @click.prevent="$validator.validateAll()"
      @click="switchStep"
      :disabled="isComputed"
    >
      Continue
    </button>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import { ErrorBag } from "vee-validate";
import { parseAndConvertKitId } from "../../mixins/parseAndConvertKitId";

export default {
  name: "Step1",
  mixins: [parseAndConvertKitId],
  directives: { mask },
  data() {
    return {
      verifyKit: "",
      enterKit: "",
      errorCase: null,
      contact_link: 'https://www.gotmold.com/#contact-us',
    };
  },
  computed: {
    ...mapGetters(["serverValidation"]),
    isComplete() {
      return this.verifyKit && this.enterKit;
    },
    isComputed() {
      return (
        this.enterKit !== this.verifyKit ||
        this.verifyKit === "" ||
        this.enterKit === ""
      );
    }
  },

  watch: {
    serverValidation(error) {
      this.errors.items = [];
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
      if(this.serverValidation.length > 0 && this.serverValidation[0].message == 'exists validation failed on kit_id') {
        this.errorCase = 'exist_validation';
      }else if(this.serverValidation.length > 0 && this.serverValidation[0].message == 'Kit ID already registered. Sign in!') {
        this.errorCase = 'already_registered';
      }else if(this.serverValidation.length > 0 && this.serverValidation[0].message == 'This Kit has been archived') {
        this.errorCase = 'archived';
      } else {
        this.errorCase = null;
      }
    },
    verifyKit() {
      this.verifyKit = this.verifyKit.toUpperCase();
    },
    enterKit() {
      this.enterKit = this.enterKit.toUpperCase();
    }
  },
  methods: {
    paste(e) {
      e.preventDefault();
    },
    ...mapMutations(["clearServerValidationErrors"]),
    validate() {
      this.errors.clear();
    },
    ...mapActions(["userInfo", "checkKitId", "saveNumber"]),
    switchStep() {
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      this.errors.clear();
      const kitId = {
        kit_id: this.parseKitId(this.enterKit),
        kit_id_confirmation: this.parseKitId(this.verifyKit)
      };
      this.checkKitId(kitId).then(res => {
        const contacts = {
          phone: "",
          mail: ""
        };
        this.saveNumber(contacts);
        this.clearServerValidationErrors();
        this.$emit("nextStep", 1);
      });
    },
    setError(str) {
      return str;
    }
  },
  mounted() {
    if (localStorage.getItem("actkitid")) {
      this.verifyKit = localStorage.getItem("actkitid");
      this.enterKit = localStorage.getItem("actkitid");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.com {
  margin: 36px 0 0 0;
}
.input {
  padding: 17px 20px;
  color: $gray;
  width: 100%;
  font-size: 16px;
  margin: 0;
  outline: none;
  border-radius: 10px;
  text-align: center;
  border: 1px solid #cccccc;
  font-family: TTNormsMedium, sans-serif;
  text-transform: uppercase;
}
.input::placeholder {
  font-family: TTNormsMedium, sans-serif;
  text-transform: capitalize;
  color: $lightGray;
  font-size: 16px;
}
.input-wrap {
  margin: 0 0 30px;
  position: relative;
}
.input.invalid {
  border: 1px solid $red;
}
.input:focus {
  border: 1px solid rgb(77, 144, 254);
}
.input.invalid:focus {
  border: 1px solid rgb(77, 144, 254);
}
.bottom-position {
  bottom: -22px;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsMedium, sans-serif;
}
.login-link {
  color: #005eb8;
}
</style>
